import { AbstractControl, UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';

export class FormHelper {
  public static setFieldDisabledStatus(control: AbstractControl, isEnabled: boolean) {
    if (!control) {
      return;
    }
    if (isEnabled) {
      control.enable();
    } else {
      control.disable();
    }
  }

  public static updateTreeValidity(group: UntypedFormGroup | UntypedFormArray, showImmediate = false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.controls[key];
      if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray) {
        this.updateTreeValidity(abstractControl, showImmediate);
      } else {
        if (showImmediate || !!abstractControl.value) {
          abstractControl.markAsTouched();
          abstractControl.markAsDirty();
        }
        abstractControl.updateValueAndValidity();
      }
    });
  }
}

